import axios from 'axios'

export async function getLogIn (email, password) {
  const url = `/logowanie?email=${email}&passwd=${encodeURIComponent(password)}&back=my-account&SubmitLogin=Logowanie&ajax=true`
  const response = await axios.post(url)
  const data = response.data
  return data

  // if (data) {
  //   return data
  // } else {
  //   throw new Error('Can not get log-in')
  // }
}



// WEBPACK FOOTER //
// ./src/api/auth/getLogIn.js